'use client'

import { motion } from 'framer-motion'

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (custom = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay: custom * 0.2, duration: 0.7, ease: 'easeOut' },
  }),
}

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="py-12 md:px-0">
      <div className="mx-auto max-w-7xl">
        {/* Title */}
        <motion.h2
          className="mb-4 text-center text-3xl font-bold text-[#132142] md:text-start md:text-4xl"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.7 }}
          variants={fadeUp}
        >
          Unsere Volks-Photovoltaik für 0,- € Anzahlung
        </motion.h2>
        {/* Gold line and squiggle */}
        <motion.div
          className="mb-5 flex items-center gap-2"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
          custom={0.2}
        >
          <div className="mr-2 hidden h-1 w-52 rounded-lg bg-[#ff4500] md:block"></div>
          <svg height="12" width="100" className="hidden md:block"></svg>
        </motion.div>
        {/* Content Grid */}
        <div className="items-center gap-8 md:grid md:grid-cols-2">
          {/* Left: Video & Note */}
          <motion.div
            className="mb-8 md:mb-0"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeUp}
            custom={0.3}
          >
            <div className="overflow-hidden rounded-2xl bg-white shadow-lg">
              {/* Replace with your own video embed or static image */}
              <div className="relative h-[300px] w-full md:h-[320px]">
                <iframe
                  className="absolute h-full w-full"
                  src="https://www.youtube.com/embed/jYXA7Mtb2Ic"
                  title="Startseiten Video Final"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              </div>
              <div className="bg-gray-50 p-4 text-sm font-medium text-gray-700">
                9 kWp, 20 x 450 Wp Glas Glas Bifazial Blackframe Module, 10.66 kWh Dynes Speicher,
                E.on Energiemanagement, Inbetriebnahme & Installation für 13.900 €
              </div>
            </div>
          </motion.div>
          {/* Right: Info & KPIs */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeUp}
            custom={0.4}
          >
            <motion.p
              className="text-center text-lg text-[#21262b] md:text-start"
              variants={fadeUp}
              custom={0.5}
            >
              Wir bieten Ihnen ein ganzheitliches Volks-Energiesystem, mit der Sie langfristig Geld
              einsparen und Ihr Eigentum aufwerten. Vereinbaren Sie jetzt ein kostenloses und
              unverbindliches Beratungsgespräch mit unseren erfahrenen Fachberatern.
            </motion.p>
            {/* KPIs */}
            <motion.div className="mb-8 grid grid-cols-2 gap-8" variants={fadeUp} custom={0.6}>
              <motion.div variants={fadeUp} custom={0.7}>
                <div className="text-center text-4xl font-bold text-[#ff4500] md:text-start">
                  20+
                </div>
                <div className="mt-1 text-center text-base text-[#21262b] md:text-start">
                  Branchen-Erfahrung
                </div>
              </motion.div>
              <motion.div variants={fadeUp} custom={0.8}>
                <div className="text-center text-4xl font-bold text-[#ff4500] md:text-start">
                  1 000+
                </div>
                <div className="mt-1 text-center text-base text-[#21262b] md:text-start">
                  Installierte Solaranlagen
                </div>
              </motion.div>
              <motion.div variants={fadeUp} custom={0.9}>
                <div className="text-center text-4xl font-bold text-[#ff4500] md:text-start">
                  13 GWh
                </div>
                <div className="mt-1 text-center text-base text-[#21262b] md:text-start">
                  Selbsterzeugte Energie
                </div>
              </motion.div>
              <motion.div variants={fadeUp} custom={1.0}>
                <div className="text-center text-4xl font-bold text-[#ff4500] md:text-start">
                  1M+
                </div>
                <div className="mt-1 text-center text-base text-[#21262b] md:text-start">
                  Gespartes Geld
                </div>
              </motion.div>
            </motion.div>
            {/* CTA Button */}
            <motion.a
              href="/termin"
              className="block w-full rounded-xl bg-[#ff4500] py-4 text-center text-lg font-bold text-white shadow transition-colors hover:scale-102 hover:bg-[#e03e00]"
              variants={fadeUp}
              custom={1.1}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
            >
              Beratungsgespräch jetzt vereinbaren!
            </motion.a>
            <motion.div
              className="mt-2 text-center text-xs text-gray-500"
              variants={fadeUp}
              custom={1.2}
            >
              *Kostenlos &amp; verpflichtungsfrei
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}
